export function UrlService (){
  const isDevelopment = process.env.NODE_ENV === 'development';
    return isDevelopment
      ? 'http://localhost:8888/whatsappbusinessapi/'
      : '/whatsappbusinessapi/';
}
